import { type ReactNode } from 'react';
import { Box, ButtonBase, Typography } from '@mui/material';
import { ContentBox } from '@/components/shared/content-box';

interface ClickableCardProps {
  title: string;
  subtitle?: string;
  description: string;
  onClick: () => void;
  image?: ReactNode;
}

export const ClickableCard = ({
  title,
  subtitle,
  description,
  image,
  onClick,
}: ClickableCardProps) => (
  <ButtonBase
    onClick={onClick}
    sx={{ textAlign: 'left', width: '100%' }}
    aria-label="Card de plano personalizado"
  >
    <ContentBox
      spacing={3}
      direction={{ xs: 'column', md: 'row' }}
      width="100%"
    >
      {image}
      <Box>
        <Typography variant="h3">{title}</Typography>
        {subtitle && <Typography variant="body2">{subtitle}</Typography>}
        {description && <Typography mt={2}>{description}</Typography>}
      </Box>
    </ContentBox>
  </ButtonBase>
);
